import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";
import {
  experienciasFijoLoading, experienciasFijoSuccess, experienciasFijoAppend, experienciasFijoFailure,
  experienciasFinDeSemanaLoading, experienciasFinDeSemanaSuccess, experienciasFinDeSemanaAppend, experienciasFinDeSemanaFailure,
  experienciasTopLoading, experienciasTopSuccess, experienciasTopAppend, experienciasTopFailure,
} from "./experienciasSlice";

// Mapear items para que tengan `uid` compatible con TicketCarousel
const mapItems = (items = []) =>
  items.map((item) => ({ ...item, uid: `experiencia-${item.id}` }));

const buildParams = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.tipo) params.append('tipo', filters.tipo);
  if (filters.categoria) params.append('categoria', filters.categoria);
  if (filters.q && filters.q.trim()) params.append('q', filters.q.trim());
  params.append('page', String(filters.page || 1));
  params.append('limit', String(filters.limit || 10));
  return params.toString();
};

// --- Panoramas Fijos ---
export const getExperienciasFijo = createAsyncThunk(
  "experiencias/getExperienciasFijo",
  async (filters = {}, { dispatch, rejectWithValue }) => {
    dispatch(experienciasFijoLoading());
    try {
      const { data } = await api.get(`/experiencias?${buildParams({ ...filters, tipo: 'fijo' })}`);
      dispatch(experienciasFijoSuccess({ items: mapItems(data.data), pagination: data.pagination, filters }));
      return data;
    } catch (err) {
      dispatch(experienciasFijoFailure());
      return rejectWithValue(err.response?.data?.message || "Error al obtener panoramas fijos");
    }
  }
);

export const loadMoreExperienciasFijo = createAsyncThunk(
  "experiencias/loadMoreExperienciasFijo",
  async (filters = {}, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.get(`/experiencias?${buildParams({ ...filters, tipo: 'fijo' })}`);
      dispatch(experienciasFijoAppend({ items: mapItems(data.data), pagination: data.pagination }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error al cargar más");
    }
  }
);

// --- Panoramas Fin de Semana ---
export const getExperienciasFinDeSemana = createAsyncThunk(
  "experiencias/getExperienciasFinDeSemana",
  async (filters = {}, { dispatch, rejectWithValue }) => {
    dispatch(experienciasFinDeSemanaLoading());
    try {
      const { data } = await api.get(`/experiencias?${buildParams({ ...filters, tipo: 'findesemana' })}`);
      dispatch(experienciasFinDeSemanaSuccess({ items: mapItems(data.data), pagination: data.pagination, filters }));
      return data;
    } catch (err) {
      dispatch(experienciasFinDeSemanaFailure());
      return rejectWithValue(err.response?.data?.message || "Error al obtener panoramas fin de semana");
    }
  }
);

export const loadMoreExperienciasFinDeSemana = createAsyncThunk(
  "experiencias/loadMoreExperienciasFinDeSemana",
  async (filters = {}, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.get(`/experiencias?${buildParams({ ...filters, tipo: 'findesemana' })}`);
      dispatch(experienciasFinDeSemanaAppend({ items: mapItems(data.data), pagination: data.pagination }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error al cargar más");
    }
  }
);

// --- Panoramas TOP ---
export const getExperienciasTop = createAsyncThunk(
  "experiencias/getExperienciasTop",
  async (filters = {}, { dispatch, rejectWithValue }) => {
    dispatch(experienciasTopLoading());
    try {
      const { data } = await api.get(`/experiencias?${buildParams({ ...filters, tipo: 'top' })}`);
      dispatch(experienciasTopSuccess({ items: mapItems(data.data), pagination: data.pagination, filters }));
      return data;
    } catch (err) {
      dispatch(experienciasTopFailure());
      return rejectWithValue(err.response?.data?.message || "Error al obtener panoramas top");
    }
  }
);

export const loadMoreExperienciasTop = createAsyncThunk(
  "experiencias/loadMoreExperienciasTop",
  async (filters = {}, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.get(`/experiencias?${buildParams({ ...filters, tipo: 'top' })}`);
      dispatch(experienciasTopAppend({ items: mapItems(data.data), pagination: data.pagination }));
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error al cargar más");
    }
  }
);
